export default __webpack_public_path__ + "static/media/729.7ec931ad.jpg";